/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  KillswitchBatchUserBadgesRequest,
  KillswitchBatchUserBadgesRequest$Outbound,
  KillswitchBatchUserBadgesRequest$outboundSchema,
} from "../components/killswitchbatchuserbadgesrequest.js";

export type KillswitchesBatchUserBadgesSecurity = {
  sessionHeaderGramSession: string;
};

export type KillswitchesBatchUserBadgesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  killswitchBatchUserBadgesRequest: KillswitchBatchUserBadgesRequest;
};

/** @internal */
export type KillswitchesBatchUserBadgesSecurity$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const KillswitchesBatchUserBadgesSecurity$outboundSchema: z.ZodMiniType<
  KillswitchesBatchUserBadgesSecurity$Outbound,
  KillswitchesBatchUserBadgesSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function killswitchesBatchUserBadgesSecurityToJSON(
  killswitchesBatchUserBadgesSecurity: KillswitchesBatchUserBadgesSecurity,
): string {
  return JSON.stringify(
    KillswitchesBatchUserBadgesSecurity$outboundSchema.parse(
      killswitchesBatchUserBadgesSecurity,
    ),
  );
}

/** @internal */
export type KillswitchesBatchUserBadgesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  KillswitchBatchUserBadgesRequest: KillswitchBatchUserBadgesRequest$Outbound;
};

/** @internal */
export const KillswitchesBatchUserBadgesRequest$outboundSchema: z.ZodMiniType<
  KillswitchesBatchUserBadgesRequest$Outbound,
  KillswitchesBatchUserBadgesRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    killswitchBatchUserBadgesRequest:
      KillswitchBatchUserBadgesRequest$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      killswitchBatchUserBadgesRequest: "KillswitchBatchUserBadgesRequest",
    });
  }),
);

export function killswitchesBatchUserBadgesRequestToJSON(
  killswitchesBatchUserBadgesRequest: KillswitchesBatchUserBadgesRequest,
): string {
  return JSON.stringify(
    KillswitchesBatchUserBadgesRequest$outboundSchema.parse(
      killswitchesBatchUserBadgesRequest,
    ),
  );
}
